<template>
  <v-card :disabled="loading">
    <div class="text-xs-right close">
      <a href="#" @click.prevent="cancel">
        <IconBase icon-name="close">
          <ClosePopupIcon />
        </IconBase>
      </a>
    </div>
    <v-card-title>
      <h1 class="card-title">Available markets</h1>
    </v-card-title>
    <v-card-text class="card-text">
      <p>
        <v-form ref="form" v-model="formValidated">
          <v-autocomplete
            ref="marketsref"
            v-model="selectedMarketName"
            :items="marketsFlattened"
            clearable
            hide-details
            hide-selected
            autofocus
            item-text="title"
            item-value="name"
            placeholder="Market name"
            class="mb-4 select-list"
            :menu-props="{ contentClass: 'openorders-dropdown' }"
            :rules="rules.selectedMarketName"
          >
            <template v-slot:no-data>
              <v-list-tile>
                <v-list-tile-title>
                  Search for a
                  <strong>market</strong>...
                </v-list-tile-title>
              </v-list-tile>
            </template>
            <template v-slot:item="{ item }">
              <v-list-tile-avatar v-if="item.exchange" :size="20" :tile="true">
                <img
                  :src="'/img/' + item.exchange + '_logo.svg'"
                  :alt="item.exchange"
                  width="20"
                  height="20"
                />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-text="item.title">
                  {{ item }}
                </v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-form>
      </p>
      <v-btn
        class="btn-ok"
        :disabled="!formValidated"
        :loading="loading"
        @click="confirm"
      >
        Add
      </v-btn>
      <v-btn class="ml-1 btn-cancel" @click="cancel">
        Cancel
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.close {
  padding-right: 24px;
  padding-top: 24px;
}
.card-text {
  padding-right: 48px;
  padding-left: 48px;
  padding-bottom: 56px;
}
.v-card__title {
  padding-left: 48px !important;
  padding-top: 4px !important;
  padding-bottom: 8px !important;
}
>>> .v-list__tile__avatar {
  min-width: 36px;
}
>>> .error--text {
  color: #2b4889 !important;
  caret-color: #2b4889 !important;
}
>>> .theme--light .v-select__slot .v-icon {
  color: #103a84;
}
>>> .theme--light .v-list__tile__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}
>>> .theme--light .v-list__tile {
  padding-left: 24px !important;
}

>>> .theme--light.v-input input::placeholder,
>>> .theme--light.v-input textarea::placeholder {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #7395d0;
}
>>> .theme--light .select-list .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}
>>> .theme--light .select-list .v-select__slot {
  border: 1px solid #7395d0;
  box-sizing: border-box;
  border-radius: 30px;
  padding-left: 8px;
  padding-right: 8px;
  height: 40px;
}
>>> .theme--light .select-list .v-select__slot .v-select__selections {
  padding-left: 16px;
}
.theme--light .btn-ok {
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
  box-shadow: none !important;
  margin-left: 0px !important;
  padding: 10px 32px 12px;
}
.theme--light .btn-cancel {
  background: #e6efff !important;
  border-radius: 40px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #103a84;
  box-shadow: none !important;
  padding: 10px 46px 12px;
}
.theme--light .card-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #103a84;
}
.theme--light .confirm-title,
>>> .theme--light .v-list__tile__title,
>>> .theme--light .v-input__icon--append,
>>> .theme--light .v-input__icon--clear,
>>> .theme--light .v-text-field__suffix {
  color: #103a84;
}
>>> .theme--light .v-list__tile__sub-title {
  color: #7395d0;
}
.theme--light p {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #8691a4;
}
>>> .theme--light.v-text-field > .v-input__control > .v-input__slot::before {
  border-color: #b8d2ff;
}
>>> .theme--light.v-input:not(.v-input--is-disabled) input,
>>> .theme--light.v-input:not(.v-input--is-disabled) textarea {
  color: #103a84;
}
/*************************/
.theme--dark .btn-ok {
  background: linear-gradient(180deg, #468aff 0%, #0051dd 100%);
  border-radius: 30px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #e9e9e9;
  box-shadow: none !important;
  margin-left: 0px !important;
  padding: 10px 32px 12px;
}
.theme--dark .btn-cancel {
  background: #959596 !important;
  border-radius: 40px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #212121;
  box-shadow: none !important;
  padding: 10px 46px 12px;
}
.theme--dark .card-title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  color: #e9e9e9;
}

>>> .theme--dark .v-list__tile__title,
>>> .theme--dark .v-input__icon--append,
>>> .theme--dark .v-input__icon--clear,
>>> .theme--dark .v-text-field__suffix {
  color: rgba(235, 235, 245, 0.3);
}
.theme--dark .confirm-title {
  color: #e9e9e9;
}
>>> .theme--dark .v-list__tile__sub-title {
  color: #e9e9e9;
}
.theme--dark p {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #959596;
}
>>> .theme--dark.v-text-field > .v-input__control > .v-input__slot::before {
  border-color: rgba(235, 235, 245, 0.3);
}
>>> .theme--dark.v-input:not(.v-input--is-disabled) input,
>>> .theme--dark.v-input:not(.v-input--is-disabled) textarea {
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark .v-input--is-focused.primary--text .v-icon {
  color: rgba(235, 235, 245, 0.3) !important;
}
>>> .theme--dark .v-select__slot .v-icon {
  color: #ffffff !important;
}
>>> .theme--dark .v-list__tile__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: #ffffff;
}
>>> .theme--dark .v-list__tile {
  padding-left: 24px !important;
}
>>> .theme--dark.v-list {
  background: #303030;
}
>>> .theme--dark.v-input.v-input--is-focused.primary--text {
  color: rgba(235, 235, 245, 0.3) !important;
  caret-color: rgba(235, 235, 245, 0.3) !important;
}

>>> .theme--dark .select-list .v-select__selection.v-select__selection--comma {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark .select-list .v-select__slot {
  border: 1px solid rgba(235, 235, 245, 0.6);
  box-sizing: border-box;
  border-radius: 30px;
  padding-left: 8px;
  padding-right: 8px;
  height: 40px;
}
>>> .theme--dark .select-list .v-select__slot .v-select__selections {
  padding-left: 16px;
}

@media (max-width: 600px) {
  .card-text {
    padding-right: 16px;
    padding-left: 16px;
    padding-bottom: 16px;
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import IconBase from "../icons/IconBase";
import ClosePopupIcon from "../icons/ClosePopupIcon";
import marketToggler from "../../mixins/marketToggler";

export default {
  name: "AddSelectedMarket",
  components: {
    IconBase,
    ClosePopupIcon
  },
  mixins: [marketToggler],
  data() {
    return {
      loading: false,
      selectedMarketName: null,
      selectedMarket: {
        base_currency: null,
        target_currency: null,
        name: null
      },
      buyPrice: null,
      quantity: null,
      formValidated: false,
      rules: {
        selectedMarketName: [v => !!v || "Market cannot be empty"]
      }
    };
  },
  created: function() {
    if (!this.$store.getters["markets/marketsAll"]) {
      this.$store.dispatch("markets/fetchMarketsAll");
    }
    if (!this.$store.getters["markets/markets"]) {
      this.$store.dispatch("markets/fetchMarkets");
    }
  },
  watch: {
    selectedMarketName() {
      if (
        typeof this.selectedMarketName !== "undefined" &&
        this.selectedMarketName !== null &&
        this.selectedMarketName.length > 0
      ) {
        const market = this.marketsFlattened.find(
          item => item.name === this.selectedMarketName
        );

        if (typeof market !== "undefined") {
          this.selectedMarket = market;
          return;
        }
      }

      return (this.selectedMarket = {
        base_currency: null,
        target_currency: null,
        name: null
      });
    }
  },
  methods: {
    focus: function() {
      this.$nextTick(() => {
        this.$refs.marketsref.isFocused = true;
      });
    },
    confirm() {
      if (this.loading) {
        return;
      }
      return this.submit();
    },
    cancel() {
      this.selectedMarketName = null;
      this.$emit("closeFundModal", "");
    },
    async submit() {
      this.loading = true;

      let market = this.marketsFlattened.find(
        item => item.name === this.selectedMarketName
      );

      await this.enableMarket(market, this.themeDark);

      this.loading = false;
      this.cancel();
    }
  },
  computed: {
    ...mapGetters({
      marketsFlattened: "markets/marketsForSelectedList",
      themeDark: "settings/darkmode"
    })
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/markets/AddSelectedMarket.vue